// libs
import React, { memo, useState } from 'react';

//components
import { WishlistButton } from './style';
import LoginNudge from 'shared/components/OTPVerification/LoginNudge';

// hooks
import { useKeyboardClick } from 'shared/hooks/useKeyboardClick';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

// constants
import { WISHLIST as WHISLIST_PATHNAME } from 'shared/constants/uri';
import { WISHLIST_INTERACTION } from 'shared/helpers/analytics/constants/wishlist';

// defs
interface IWishlist {
  wishlistEnabled: boolean;
  isLoggedInUser: boolean;
}

//helpers
import { useAuthModalWrapperContext } from 'shared/components/AuthModal/AuthModalWrapperContext';
import NFA from 'shared/helpers/analytics/NFAnalytics';

// color
import { LOGIN_LOCATIONS } from 'shared/helpers/analytics/constants/loginEvents';

// constants
const ARIA_LABELS = {
  VIEW_WISHLIST: 'View wishlist',
};

function Wishlist({ wishlistEnabled, isLoggedInUser }: IWishlist) {
  // Get store-aware wishlist icon
  const WishlistIcon = useStoreIcon(IconName.WISHLIST);

  const [shouldShowLoginNudge, setShowLoginNudge] = useState(false);

  const { showBottomSheetAuth } = useAuthModalWrapperContext();

  const hideLoginNudge = () => {
    setShowLoginNudge(false);
  };
  const wishlistClicked = () => {
    const data = {
      wishlistInteractionLocation: WISHLIST_INTERACTION.WISHLIST_ICON,
      pageviewLoacation: `${NFA.pageProperties.pagename}: ${LOGIN_LOCATIONS.WISHLIST_ICON_TOP_NAV}`,
    };

    NFA.updateDatalayerBeforeNext(data);

    if (!isLoggedInUser) {
      NFA.updateDataLayer({
        loginPage: '',
        loginLocation: LOGIN_LOCATIONS.WISHLIST_ICON_TOP_NAV,
      });

      showBottomSheetAuth(WHISLIST_PATHNAME, false, 'wishlist-access');
    } else {
      window.location.href = WHISLIST_PATHNAME;
    }
  };

  const keyboardProps = useKeyboardClick(wishlistClicked);

  if (!wishlistEnabled) {
    return null;
  }

  return (
    <>
      <WishlistButton
        {...keyboardProps}
        aria-label={ARIA_LABELS.VIEW_WISHLIST}
        data-at="wishlist-button"
      >
        <WishlistIcon aria-hidden="true" />
      </WishlistButton>
      {shouldShowLoginNudge && (
        <LoginNudge onNudgeHide={hideLoginNudge} redirectTo={WHISLIST_PATHNAME} />
      )}
    </>
  );
}

export default memo(Wishlist);
